import type { ComponentPropsWithoutRef } from 'react'

// 見た目は直後のCheckBoxLabelがpeer-checked等で描画する（inputとlabelは必ず隣接させて使う）
const CheckBoxInput = ({ className = '', ...props }: ComponentPropsWithoutRef<'input'>) => <input className={`peer hidden ${className}`} {...props} />

export default CheckBoxInput
